// extracted by mini-css-extract-plugin
export default {"MyChannels":"MyChannels_MyChannels__kVL-c","ChannelsContainer":"MyChannels_ChannelsContainer__i+eQk","SubText":"MyChannels_SubText__wXs8X"};